import type React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const SettingsPageSkeleton: React.FC = () => (
  <div className="flex flex-col h-screen w-full">
    <div className="flex-none bg-background w-full">
      <div className="container mx-auto p-6">
        <div className="space-y-4">
          <Skeleton className="h-8 w-32" />
          <Skeleton className="h-4 w-96" />
        </div>
      </div>
    </div>

    <div className="flex-1 overflow-auto p-6">
      <div className="max-w-2xl space-y-6">
        {/* Settings sections */}
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="border rounded-lg p-6 space-y-4">
            <Skeleton className="h-6 w-40" />
            <div className="space-y-3">
              <div className="space-y-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-10 w-full" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-10 w-full" />
              </div>
            </div>
            <div className="pt-4 border-t">
              <Skeleton className="h-9 w-20" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)

export { SettingsPageSkeleton }
